import OmronFooter from "components/OmronFooter";
import OmronHeader from "components/OmronHeader";
import PageTitle from "components/PageTitle";
import { selectEmail } from "features/signup";
import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import styled from "styled-components";

const SignupCompletePage: React.FC = (): JSX.Element => {
  const { t } = useTranslation();
  const email = useSelector(selectEmail);

  return (
    <MainWrapper>
      <OmronHeader
        link={{ path: "/", label: t("common.label.breadcrumbsSignin") }}
        label={[
          t("common.label.breadcrumbsSignup"),
          t("common.label.breadcrumbsSignupConf"),
          t("common.label.breadcrumbsSignupComplete"),
        ]}
      />
      <PageMain>
        <InnerDiv>
          <PageTitle title={t("signupPage.label.completeTitle")} text="" />
          <Text>
            {t("signupPage.text.completeSendEmail")}
            <br />
            {email}
            <br />
            {t("signupPage.text.completeAddress")}
            <br />
            {t("signupPage.text.completeNotSendEmail")}
            <br />
            <Link
              href="https://www.fa.omron.co.jp/product/tool/ss-video-manual/en/licence-help/index.html"
              target="_blank"
            >
              {t("signupPage.text.completeSupportEnglish")}
              <br />
            </Link>
            <Link
              href="https://www.fa.omron.co.jp/product/tool/ss-video-manual/ja/licence-help/index.html"
              target="_blank"
            >
              {t("signupPage.text.completeSupportJapanese")}
            </Link>
          </Text>
        </InnerDiv>
      </PageMain>
      <OmronFooter />
    </MainWrapper>
  );
};

export default SignupCompletePage;

const PageMain = styled.main`
  grid-area: main;
  padding: 3.2rem 50px;
`;

const InnerDiv = styled.div`
  width: 1000px;
  margin: 0 auto;
`;

const MainWrapper = styled.div`
  display: grid;
  grid-template-rows: 76px 40px 1fr auto;
  grid-template-areas:
    "header"
    "breadc"
    "main"
    "footer";
  min-height: 100vh;
`;
const Text = styled.p`
  margin-bottom: 3rem;
  font-size: 14px;
  line-height: 1.7;
  letter-spacing: 0;
  font-weight: normal;
`;
const Link = styled.a`
  color: #005eb8;
  padding-left: 15px;
`;
